import { useState } from 'react';
import info from 'assets/images/svg/new-plan/info.svg';
import './tooltip.scss';

type TooltipProps = {
  title?: string;
  subTitle?: string;
};

const Tooltip: React.FC<TooltipProps> = (props: TooltipProps) => {
  const { title, subTitle } = props;

  const [showInfo, setShowInfo] = useState(false);

  const showTooltipInfo = () => {
    setShowInfo(!showInfo);
  };

  return (
    <div className="tooltip">
      <img src={info} alt={info} onClick={showTooltipInfo} />
      <div
        className="tooltip__content"
        style={{ display: showInfo ? 'block' : 'none' }}
      >
        <div className="tooltip__content__card">
          <h5 className="tooltip__content__card--title">{title}</h5>
          <h6 className="tooltip__content__card--sub-title">{subTitle}</h6>
        </div>
      </div>
    </div>
  );
};

export default Tooltip;

Tooltip.defaultProps = {
  title: '',
  subTitle: '',
};
